import useReveal from '../hooks/useReveal';
import './styles/timeline.css';
import {  TIMELINE } from "../constants.js"


const WorkIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <rect x="2" y="7" width="20" height="14" rx="2" />
    <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
  </svg>
);

const EduIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M22 10l-10-7L2 10l10 7 10-7z" />
    <path d="M6 12v5c0 1.657 2.686 3 6 3s6-1.343 6-3v-5" />
  </svg>
);

export default function Timeline() {
  const ref = useReveal();

  return (
    <section id="timeline" className="section" ref={ref}>
      <h1 className="reveal">Experience {"{"}</h1>

      <div className="timeline">
        {TIMELINE.map((item, i) => (
          <div key={i} className={`timeline-item reveal ${item.type}`}>
            <div className="timeline-icon">
              {item.type === 'work' ? <WorkIcon /> : <EduIcon />}
            </div>
            <div className="timeline-card surface">
              <div className="timeline-header">
                <div>
                  <h3 className="timeline-title">{item.title}</h3>
                  <span className="timeline-org">{item.organization}</span>
                </div>
                <span className="timeline-date">{item.date}</span>
              </div>
              {item.description && (
                <p className="timeline-desc">{item.description}</p>
              )}
            </div>
          </div>
        ))}
      </div>

      <h1 className="reveal">{"}"}</h1>
    </section>
  );
}